/**
 * @file reset-password.tsx
 *
 * @fileoverview This is the password reset page and is accessed by going to "/user/password-reset".
 * The page displays a form for the user to provide an email address and on submit will make a call the backend
 * to send a verification email.
 */
import JobiqoPasswordReset, {
  getServerSideProps,
} from '~/jobiqo/pages/user/reset-password';
export default JobiqoPasswordReset;
export { getServerSideProps };
